import React, { useEffect, useState, useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { getUserProfile } from "helpers";
import { useAuth0 } from "@auth0/auth0-react";

export const ReviewButton = (props) => {
    const { buttonId, noteDetail } = props;
    const dataContext = useContext(TemplateContext);
    const { content: formatContent, ...rest } = dataContext || {};

    const [authData, setAuthData] = useState(null);
    const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
    const { isPreview } = formatContent?.storyContainer?.data;

    useEffect(() => {
        if (!isPreview) {
            if (!document.querySelector(`link[href="${process.env.NEXT_PUBLIC_API_RECIPE_REVIEWS}/statics/plugins/recetas/assets/pluginrazor.css"]`)) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = `${process.env.NEXT_PUBLIC_API_RECIPE_REVIEWS}/statics/plugins/recetas/assets/pluginrazor.css`;
                document.head.appendChild(link);
            }

            if (!document.querySelector(`script[src="${process.env.NEXT_PUBLIC_API_RECIPE_REVIEWS}/statics/plugins/recetas/assets/pluginrazor.js"]`)) {
                const script = document.createElement("script");
                script.type = "module";
                script.src = `${process.env.NEXT_PUBLIC_API_RECIPE_REVIEWS}/statics/plugins/recetas/assets/pluginrazor.js`;
                document.head.appendChild(script);
            }

            const fetchAuthData = async () => {
                try {
                    const token = await getAccessTokenSilently();
                    const user = getUserProfile();

                    setAuthData({
                        auth0Token: token,
                        subscribed: true,
                        dataUser: {
                            name: user?.name,
                            picture: user?.picture,
                        },
                    });
                } catch (error) {
                    console.error("Error al obtener autenticación:", error);
                }
            }

            fetchAuthData();
        };
    }, []);

    const sectionWithUnderscore = "_7_";
    const noteIdWithSection = sectionWithUnderscore+noteDetail?._id;


    const handleRedirect = async () => {
        const userProfile = getUserProfile();
        if (!userProfile?.id) {
            redirectLogin();
            return;
        }
    }

    const redirectLogin = async () => {
        let expDate = getExpireDate(1);
        document.cookie = `auth0_redir=${
            window.location.href
        };expires=${expDate.toUTCString()};path=/`;
        loginWithRedirect();
    };

    return (
        <div
            id={buttonId}
            className="puntuar"
            data-jwt={authData?.auth0Token}
            data-subscriptionStatus={"true"}
            data-nota-id={noteIdWithSection}
            data-user={JSON.stringify(authData?.dataUser)}
            data-stage="production"
            onClick={() => {
                if (!authData) {
                    handleRedirect();
                }
            }}
        />
    )
}
